import * as types from "../actions/types";


const initialState = {
    playlist: null,
    playlistAccessLevel: 0,
    contents: null,
    videomessages: null,
    secondarycontents: null,
    storageSpace: null,
    storage: null,
    compositions: null,
    secondarycompositions: null,
    playlists: null,
    secondaryplaylists: null,
    schedules: null,
    styles: null,
    secondarystyles: null,
    uploadProgress: 0
};


export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_PLAYLIST_COMPLETED:
            return Object.assign({}, state, {
                playlist: action.payload.playlist,
                playlistAccessLevel: action.payload.userAccessLevel
            });
        case types.GET_CONTENTS_COMPLETED:
            return Object.assign({}, state, {
                contents: action.payload
            });//GET_CONTENTS_SECONDARY_COMPLETED
        case types.GET_VIDEMESSAGES_COMPLETED:
            return Object.assign({}, state, {
                videomessages: action.payload
            });
        case types.GET_STORAGE_COMPLETED:
            return Object.assign({}, state, {
                storage: action.payload
            });
        case types.GET_CONTENTS_SECONDARY_COMPLETED:
            return Object.assign({}, state, {
                secondarycontents: action.payload
            });
        case types.GET_CONTENTS_STORAGESPACE:
            return Object.assign({}, state, {
                storageSpace: action.payload
            });
        case types.GET_COMPOSITIONS_COMPLETED:
            return Object.assign({}, state, {
                compositions: action.payload
            });
        case types.GET_COMPOSITIONS_SECONDARY_COMPLETED:
            return Object.assign({}, state, {
                secondarycompositions: action.payload
            });
        case types.GET_PLAYLISTS_COMPLETED:
            return Object.assign({}, state, {
                playlists: action.payload
            });
        case types.GET_PLAYLISTS_SECONDARY_COMPLETED:
            return Object.assign({}, state, {
                secondaryplaylists: action.payload
            });
        case types.GET_STYLESLIST_COMPLETED:
            return Object.assign({}, state, {
                styles: action.payload
            });
        case types.GET_STYLESLIST_SECONDARY_COMPLETED:
            return Object.assign({}, state, {
                secondarystyles: action.payload
            });
        case types.GET_SCHEDULES_COMPLETED:
            return Object.assign({}, state, {
                schedules: action.payload
            });
        case types.CLEAR_PLAYLIST:
            return Object.assign({}, state, {
                playlist: null,
                playlistAccessLevel: 0
            });
        case types.UPDATE_PLAYLIST_TIMESTAMP:
            console.log(state);
            var updatedPlaylist = state.playlist;
            updatedPlaylist.timestamp = action.timestamp;

            return Object.assign({}, state, {
                playlist: updatedPlaylist
            });

        default:
            return state;
    }
};
